import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { GtmService } from '@seven1/angular/gtm';

export const routeChangeActivateGuard: CanActivateFn = (route, state) => {
  const gtmService = inject(GtmService);
  gtmService.routingActivation('route', route.url);
  return true;
};
